var map = {
	"./Adequate diet.png": 68712,
	"./Anemia.png": 41130,
	"./BMI22.png": 1213,
	"./Blood Sugar.png": 36112,
	"./BmiForAge.jpg": 13733,
	"./CVD.png": 10562,
	"./Deficiency.png": 67741,
	"./HighCholesterol.png": 78958,
	"./INDICATOR WISE ICONS FOR NUTRITION ATLAS 2.docx": 70832,
	"./IYCF.png": 94596,
	"./LBW.png": 82255,
	"./LIPID PROFILE.png": 25597,
	"./Micnut Defi.png": 92468,
	"./SERUM CREATININE.png": 93053,
	"./SSFT.png": 80148,
	"./TSFT.png": 20091,
	"./Underweight.png": 81495,
	"./WAIST CIRCUMFERENCE.jpg": 87642,
	"./WaistCircumference11.jpg": 78934,
	"./antenatal care.png": 9387,
	"./bmi.png": 32875,
	"./hypertension.png": 66878,
	"./insitutional delivery.jpg": 74918,
	"./lowWeightForAge.png": 82201,
	"./lowWeightForHeight.png": 97163,
	"./muac.png": 30713,
	"./old indicator icons/ADAQUATE DIET.png": 31835,
	"./old indicator icons/BLOOD SUGAR.png": 58393,
	"./old indicator icons/BMI FOR AGE.jpg": 3544,
	"./old indicator icons/IYFC.png": 51874,
	"./old indicator icons/LIPID PROFILE.png": 83682,
	"./old indicator icons/SERUM CREATININE.jpg": 47076,
	"./old indicator icons/WAIST CIRCUMFERENCE.jpg": 56290,
	"./old indicator icons/anaemia icon.jpg": 11037,
	"./old indicator icons/antenatal care.png": 59337,
	"./old indicator icons/cardiovascular.png": 42555,
	"./old indicator icons/high cholestrol.png": 21286,
	"./old indicator icons/hypertension.png": 61753,
	"./old indicator icons/insitutional delivery.jpg": 4574,
	"./old indicator icons/low birth weight.png": 36969,
	"./old indicator icons/malnutritionimg - Copy - Copy.jpg": 18225,
	"./old indicator icons/malnutritionimg - Copy.jpg": 34421,
	"./old indicator icons/micronutrient defieciency .jpg": 32045,
	"./old indicator icons/muac.png": 24970,
	"./old indicator icons/overweight.png": 49262,
	"./old indicator icons/postnatal care.png": 82527,
	"./old indicator icons/reference image of malnutition.png": 51222,
	"./old indicator icons/stunt.jpg": 87286,
	"./old indicator icons/stunting.jpg": 12224,
	"./old indicator icons/underweight.jpg": 90861,
	"./old indicator icons/vaccination and supplmentation  icon.png": 80763,
	"./old indicator icons/wasting.jpg": 79073,
	"./overweight.png": 25598,
	"./postnatal care.png": 54942,
	"./stunting.png": 84218,
	"./vaccine.png": 69807,
	"./warning.png": 20489,
	"./wasting.png": 33652
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 70200;